module.exports = __webpack_public_path__ + "img/insert_tags_add_info.8776564f.png";